import React, { Component } from "react";
import PropTypes from "prop-types";
import TextField from "react-md/lib/TextFields";
import Button from "react-md/lib/Buttons/Button";
import { CustomerShape } from "../../../../common/proptypes";

class AddIssue extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: "",
    };

    this.handleSave = this.handleSave.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleSave() {
    const { onSave, customer } = this.props;
    onSave(this.state.value, customer.key);
    // it's fine to clear the message right here,
    // as user can see new issue in the list right after adding OR an error message
    // TODO: check if we really need manage state for this
    this.setState(() => ({
      value: "",
    }));
  }

  handleChange(value) {
    this.setState(() => ({
      value,
    }));
  }

  render() {
    const { className } = this.props;
    return (
      <div className={className}>
        <div className="md-grid">
          <h6
            className="md-cell md-cell--12 md-cell--bottom md-title profile-title"
            style={{ marginBottom: 10 }}
          >
            Add Issue
          </h6>
          <TextField
            id="issue"
            label="Issue:"
            className="md-cell md-cell--12 md-cell--bottom"
            onChange={this.handleChange}
            value={this.state.value}
            required
            rows={6}
            maxRows={8}
          />
          <Button
            raised
            primary
            onClick={this.handleSave}
            disabled={!this.state.value}
            style={{
              marginLeft: "auto",
            }}
          >
            Save
          </Button>
        </div>
      </div>
    );
  }
}

AddIssue.propTypes = {
  onSave: PropTypes.func.isRequired,
  customer: CustomerShape,
  className: PropTypes.string,
};

AddIssue.defaultProps = {
  customer: {},
  className: null,
};

export default AddIssue;



// WEBPACK FOOTER //
// ./src/customer/components/EditCustomer/AddIssue/AddIssue.jsx